import { BinIcon, PenIcon } from "assets/icons";
import { If, Media } from "components";
import { ProductsFieldForForms } from "modules/products";
import { convertProductSetDetailsToListItem } from "modules/productSets";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Button, Loader, Modal, TableItemStatus } from "ui";

import { OFFERS_STATUSES_LIST } from "../../constants";
import { formattedDate, getDifferenceInDays } from "../../helpers";
import {
  InformationItemProps,
  OfferModalProps
} from "./OfferDetailsModal.types";

import styles from "./OfferDetailsModal.module.scss";

const OfferDetailsModal = ({
  isOpen,
  onClose,
  onDelete,
  onEdit,
  sharedData,
  isLoadingData,
  bannerType
}: OfferModalProps) => {
  const { t } = useTranslation();

  const {
    image = null,
    status = "Inactive",
    title = "",
    from = new Date(),
    to = new Date(),
    createdAt = new Date(),
    productVariants = [],
    productSet
  } = sharedData ?? {};

  const InformationItem = ({
    title: itemTitle,
    information
  }: InformationItemProps) => {
    return (
      <div className={styles["offer__modal--information-item"]}>
        <p className={styles["offer__modal--information-item-title"]}>
          {t(itemTitle)}
        </p>
        {information}
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      additionalForTitle={
        <TableItemStatus
          statusesList={OFFERS_STATUSES_LIST}
          activeStatusIndex={OFFERS_STATUSES_LIST.findIndex(
            (statusItem) => statusItem?.value === status
          )}
          className={styles["offer__modal--status"]}
        />
      }
      footer={
        <div className={styles["offer__modal--footer"]}>
          <Button
            type="submit"
            variant="delete"
            icon={<BinIcon width="20" height="20" />}
            onClick={onDelete}
          >
            {t("Delete")}
          </Button>
          <Button
            type="button"
            variant="default"
            icon={<PenIcon width="20" height="20" />}
            onClick={onEdit}
          >
            {t("Edit")}
          </Button>
        </div>
      }
      className={styles.offer__modal}
      contentClassName={styles["offer__modal--content"]}
    >
      <If condition={isLoadingData}>
        <Loader />
      </If>

      {image && (
        <Media
          mediaFile={image}
          className={
            bannerType === "Banner"
              ? styles["offer__modal--banner-image"]
              : styles["offer__modal--offer-image"]
          }
        />
      )}

      <div className={styles["offer__modal--information"]}>
        <InformationItem title="From" information={formattedDate(from)} />
        <InformationItem title="To" information={formattedDate(to)} />
        <InformationItem
          title="Days left"
          information={getDifferenceInDays(moment().toISOString(), to, false)}
        />
        <InformationItem
          title="Created at"
          information={formattedDate(createdAt)}
        />
      </div>

      <div className={styles["offer__modal--products"]}>
        <ProductsFieldForForms
          productsList={productVariants}
          productSet={convertProductSetDetailsToListItem(productSet)}
        />
      </div>
    </Modal>
  );
};

export default OfferDetailsModal;
